import Footer from "../Components/Career/Footer"
import Header from "../Components/Career/Header"
import Hero from "../Components/Career/Hero"
import Perks from "../Components/Career/Perks"
import Register from "../Components/Career/Register"
import TeamOfSpeakers from "../Components/Career/TeamOfSpeakers"
import WhyAttend from "../Components/Career/WhyAttend"

const Career = () => {
  return (
    <div>
      <Header/>
      <Hero/>
      <WhyAttend/>
      <Perks/>
      <Register/>
      <TeamOfSpeakers/>
      <Footer/>
    </div>
  )
}

export default Career
